import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSideMenu from "../components/AdminSideMenu";
import AdminTopMenu from "../components/AdminTopMenu/AdminTopMenu";
import styles from "./UsersScreen.module.css";
import { useRooms } from "../contexts/RoomContext";
import { Room } from "../services/roomService";

const TranscriptionsScreen: FunctionComponent = () => {
  const navigate = useNavigate();
  const { rooms, loading, error, fetchRooms } = useRooms();
  const [filter, setFilter] = useState("");

  useEffect(() => {
    // Backend validation caps /rooms?limit at 100
    fetchRooms({ page: 1, limit: 100 });
  }, [fetchRooms]);

  const filteredRooms = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!q) return rooms;
    return rooms.filter((r: Room) => {
      const rid = (r.roomId || "").toLowerCase();
      const name = (r.name || "").toLowerCase();
      return rid.includes(q) || name.includes(q);
    });
  }, [filter, rooms]);

  const openRoom = (room: Room) => {
    if (!room.roomId) return;
    navigate(`/transcriptions/${encodeURIComponent(room.roomId)}`, {
      state: { roomName: room.name }
    });
  };

  return (
    <div>
      <AdminSideMenu />
      <AdminTopMenu />
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <div className={styles.header}>
            <h1 className={styles.headerTitle}>Transcriptions</h1>
          </div>

          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12 }}>
            <input
              type="text"
              placeholder="Search rooms (Room ID or name)..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className={styles.searchInput}
              style={{ marginBottom: 0, maxWidth: 420 }}
            />
          </div>

          {error && <div className={styles.errorContainer}><p>{error}</p></div>}

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 12 }}>
            {loading ? (
              <div className={styles.loadingContainer}>
                <div className={styles.loadingSpinner}></div>
                <p>Loading rooms...</p>
              </div>
            ) : (
              <>
                {filteredRooms.length === 0 ? (
                  <div style={{ padding: 16, border: "1px solid #eee", borderRadius: 8, background: "#fafafa" }}>
                    No rooms found.
                  </div>
                ) : (
                  filteredRooms.map((room) => (
                    <div key={room.id} style={{ border: "1px solid #e6e6e6", borderRadius: 10, padding: 14, background: "#fff" }}>
                      <div style={{ fontSize: 14, opacity: 0.8 }}>Room ID</div>
                      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>{room.roomId || "—"}</div>
                      <div style={{ fontSize: 14, opacity: 0.8 }}>Room Name</div>
                      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{room.name}</div>
                      <button
                        className={styles.addUserButton}
                        onClick={() => openRoom(room)}
                        disabled={!room.roomId}
                      >
                        View
                      </button>
                    </div>
                  ))
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TranscriptionsScreen;

